module.exports = __webpack_public_path__ + "static/KeystoneLodgeSpa.9e667e0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/resume/KeystoneLodgeSpa.jpeg
// module id = 469
// module chunks = 114276838955818